var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('v-card-title', [_vm._v("로고 " + _vm._s(_vm.isCreated ? "등록" : "수정"))]), _c('v-divider'), _c('v-row', {
    staticClass: "pa-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('image-input', {
    attrs: {
      "outlined": "",
      "flat": "",
      "width": "150",
      "aspect-ratio": 1 / 1
    },
    model: {
      value: _vm.form.image,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "image", $$v);
      },
      expression: "form.image"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-3",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "제목",
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "subject", $$v);
      },
      expression: "form.subject"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "유형",
      "items": _vm.typeItems,
      "outlined": "",
      "dense": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  })], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-switch', {
    staticClass: "ma-0 ml-2",
    attrs: {
      "label": "적용",
      "inset": true,
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.shows,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "shows", $$v);
      },
      expression: "form.shows"
    }
  }), _c('v-spacer'), _c('v-btn', {
    on: {
      "click": function click() {
        return _vm.shows = false;
      }
    }
  }, [_vm._v("취소")]), _c('v-btn', _vm._b({
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(_vm._s(_vm.isCreated ? "등록" : "수정"))])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }